var ErrorView = require('../views/error');
var PageView = require('../views/page');
var GridView = require('../views/grid');
var VoteDetailView = require('../views/vote-detail');
var WindowView = require('../views/window');
var ModalView = require('../views/modal');
var GeoView = require('../views/geo');
var LoadingView = require('../views/loading');
var FaqView = require('../views/faq');
var AuthView = require('../views/auth');
var ThanksView = require('../views/thanks');
var WinnerView = require('../views/winner');
var ReAuthView = require('../views/reauth');
var CountdownView = require('tswdg-countdown');
var TLDRC = require('tldr-child');
var PubSub = require('tscom-pubsub');

var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');

module.exports = Backbone.Router.extend({
    controller: null,
    currentView: null,
    currentModal: null,
    history: [],
    routes: {
        '': 'home',
        home: 'home',
        'error/:name': 'error',
        'loading/:name': 'loading',
        faq: 'faq',
        voting: 'voting',
        auth: 'auth',
        thanks: 'thanks',
        window: 'window',
        countdown: 'countdown'
    },
    /**
     *
     */
    initialize: function(options) {
        if (_.isUndefined(options)) {
            return;
        }
        this.initialLoad = true;

        this.controller = options.controller;
        this.cms = options.cms;
        this.facebook = options.facebook;
        this.connect = options.connect;
        this.authModel = options.auth;
        this.voteOption = options.voteOption;
        this.uniqueId = options.uniqueId;

        //pym child init
        this.pymChildId = 'telescope-app';
        this.pym = TLDRC.Child({ polling: 500, id: this.pymChildId });
        this.pym.child.id = this.pymChildId;

        this.listenTo(
            Backbone.history,
            'route',
            _.bind(this.saveHistory, this)
        );

        this.page = new PageView({
            cms: this.cms,
            voteOption: this.voteOption,
            router: this,
            uniqueId: this.uniqueId
        }).render();
        this.$body = $(options.container || document.body);
        this.$app = this.page.$('div[role="main"]');
        this.$header = this.page.$('header');
        this.$footer = this.page.$('footer');
        this.$modal = $('<div />');

        this.$body.html(
            this.page.$el.addClass(top === self ? 'frame-false' : 'frame-true')
        );
        document.body.classList.add(
            top === self ? 'frame-false' : 'frame-true'
        );
        this.$body.append(this.$modal);

        this.$modal
            .attr({
                class: 'modal',
                role: 'dialog',
                'aria-labelledby': 'modalLabel',
                'aria-hidden': 'true',
                'data-backdrop': 'static'
            })
            .on('hidden.bs.modal', _.bind(this.closedCurrentModal, this));

        this.page.updateCSS(this.cms);

        var animationFrameHandler = _.bind(function(timestamp) {
            PubSub.trigger('AnimationFrame', timestamp);
            window.requestAnimationFrame(animationFrameHandler);
        }, this);
        window.requestAnimationFrame(animationFrameHandler);

        this.listenTo(PubSub, 'facebook:rerequest',this.reauth.bind(this));
        this.listenTo(PubSub, 'modal:close', this.closeCurrentModal.bind(this));
        this.listenTo(PubSub, 'route:auth', this.auth.bind(this));
        this.listenTo(PubSub, 'route:loading', this.loading.bind(this));
        this.listenTo(PubSub, 'scrollToTop', this.scrollToTop.bind(this));
    },
    /* CLEAN IT ALL UP */
    destroy: function() {
        this.stopListening();
        if (this.page) {
            this.page.remove();
        }
        $('#' + this.uniqueId + '-style').remove();
        this.$modal.off();
        this.$modal.remove();
        this.currentView.remove();
        this.closedCurrentModal();
    },
    /**
     *
     */
    setCurrentView: function(view) {
        this.closeCurrentModal();
        this.$app.html(view.render().$el);

        var bodyContext = 'body-' + view.className;
        this.$app.alterClass('body-*', bodyContext);

        // remove old view
        if (this.currentView !== null) {
            this.currentView.remove();
            this.currentView = null;
        }
        // store current view
        this.currentView = view;
        if (typeof this.currentView.renderedToDOM === 'function') {
            this.currentView.renderedToDOM();
        }

        if (!this.initialLoad) {
            this.scrollToTop();
        }
        this.initialLoad = false;
    },
    /**
     *
     */
    customCSS: function(rootView) {
        rootView = rootView || $('body');
        var text = this.cms.get('text');

        //main_background_color
        if (text.design.css.vote_button.color)
            rootView
                .find('.vote')
                .css(
                    'background-color',
                    text.design.css.vote_button.color
                );
    },

    /**
     *
     */
    setCurrentModal: function(view) {
        var modalContext = 'modal-has-' + view.className;
        var modal = new ModalView({
            model: { view: view }
        });

        modal.$el.addClass( view.className.replace( 'view-', 'style-' ));

        this.$body.alterClass('modal-has-*', modalContext);
        this.$modal.html(modal.render().$el);

        this.$modal.modal({
            show: true,
            keyboard: false,
            backdrop: 'static'
        });

        // remove old modal
        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
        }
        // store current modal
        this.currentModal = this.controller.Views.Modal = modal;

        if (typeof view.renderedToDOM === 'function') {
            view.renderedToDOM();
        }
        if (
            this.cms.get('text').design.scrollable_background_with_modal ===
            'false'
        ) {
            $('html').css('overflow', 'hidden');
        }

        if (!this.initialLoad) {
            this.scrollToTop();
        }
        this.initialLoad = false;
    },
    /**
     *
     */
    closedCurrentModal: function() {
        console.log('MODAL HIDDEN!!');
        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
            this.$body.alterClass('modal-has-*', '');

            if ($('html').attr('style') != 'undefined') {
                $('html').removeAttr('style');
            }
        }
    },
    /**
     *
     */
    closeCurrentModal: function() {
        console.log('CLOSE CURRENT MODAL');

        if(this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.undoSelected();
            }
        }

        this.$modal.modal('hide');


        if ($('html').attr('style') != 'undefined') {
            $('html').removeAttr('style');
        }
    },
    /**
     *
     */
    home: function() {
        if(!this._isOpen()) return;

        if($('footer').hasClass('posfix')) $('footer').removeClass('posfix');
        document.body.classList.remove('geo', 'window');
        var view = new GridView({
            cms: this.cms,
            connect: this.connect,
            auth: this.authModel,
            voteOption: this.voteOption,
            router: this
        });

        this.setCurrentView(view);

        PubSub.trigger('trackGoogle',{
            category: 'Page View',
            action: 'Page View: Landing Page',
            label: 'Page View: Landing Page'
        });
    },
    /**
     * Prompt the user to grant permission
     */
    reauth: function() {
        var data = this.cms.get('text')['view_reauth'];
        var view = new ReAuthView({
            facebook: this.facebook,
            model: data
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    winner: function() {
        var view = new WinnerView({
            model: this.cms.get('text')['view_winner']
        });
        this.setCurrentView(view);
    },
    /**
     *
     */
    error: function(name) {
        var data = this.cms.get('text')['views_error'][name];
        data = _.isObject(data)
            ? data
            : this.cms.get('text')['views_error']['generic'];
        var view = new ErrorView({
            model: data,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    geo: function() {
        var data = this.cms.get('text')['views_error'].geo;
        data = _.isObject(data) ? data : this.cms.get('text')['views_error']['generic'];
        var view = new GeoView({
            model: data
        });
        this.setCurrentView(view);
    },
    /**
     *
     */
    loading: function(name) {
        var data = this.cms.get('text')['views_loading'][name];
        data = _.isObject(data)
            ? data
            : this.cms.get('text')['views_loading']['generic'];
        var view = new LoadingView({
            model: data
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    faq: function() {
        var data = this.cms.get('text')['views_faq'];
        var view = new FaqView({
            model: data,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    voting: function(model) {

        var view = new VoteDetailView({
            model: model,
            cms: this.cms,
            auth: this.authModel,
            connect: this.connect,
            voteOption: this.voteOption,
            router: this
        });

        this.setCurrentModal(view);
    },
    /**
     *
     */
    auth: function() {
        //var data = this.controller.Models.Home.get('data');
        var view = new AuthView({
            cms: this.cms,
            auth: this.authModel,
            facebook: this.facebook,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     * This is called when user closes the auth view modal
     */
    undoSelected: function() {
        // if login modal is closed undo the selected
        var selected = this.voteOption.findWhere({
            selected: true
        });
        if (_.isObject(selected))
            selected.set({selected: false}, {silent: true});
    },
    /**
     *
     */
    thanks: function() {
        var view = new ThanksView({
            controller: this.controller
        });

        this.setCurrentModal(view);
        this.listenTo(view, 'voteagain', _.bind(this.voting, this));
    },
    /**
     *
     */

    countdown: function() {
        var countdown = this.controller.Models.Countdown.toJSON();
        var cmsData = this.cms.get('text').countdown_clock;

        var model = new Backbone.Model({
            show_branding: '',
            copy_text: cmsData.description,
            show_copy_text: 1,
            show_labels: cmsData.labels.display,

            show_month: cmsData.countdown_units.show_month,
            show_days: cmsData.countdown_units.show_days,
            show_hours: cmsData.countdown_units.show_hours,
            show_minutes: cmsData.countdown_units.show_minutes,
            show_seconds: cmsData.countdown_units.show_seconds,

            time_months: countdown.time_months,
            time_days: countdown.time_days,
            time_hours: countdown.time_hours,
            time_minutes: countdown.time_minutes,
            time_seconds: countdown.time_seconds,

            style: {}
        });

        this.listenTo(this.controller.Models.Countdown, 'change', function(
            countdownModel
        ) {
            model.set(countdownModel.attributes);
        });

        var view = new CountdownView({
            controller: this.controller,
            model: model,
            className: 'countdown-view-home'
        });

        return view;
    },
    /**
     *
     */

    window: function() {
        var model = this.cms.get('text')['views_snapshot_closed'];
        var share = this.cms.get('text')['views_share'];
        var countdownCms = this.cms.get('text')['countdown_clock'];
        console.warn('model is: ' + model);
        var view = new WindowView({
            controller: this.controller,
            model: model,
            share: share
        });

        this.setCurrentView(view);
        document.body.classList.add('window');
        var show_countdown = countdownCms.enable;
        if (show_countdown === 'true') {
            var countdown = this.countdown();
            countdown.render();
            countdown.$el.insertAfter($('.text'));
            view.$el.append(countdown.$el);
        }
    },
    /**
     *
     */

    _isOpen: function() {
        // is the user out of the geographically acceptable region
        if (_.isNull(this.controller.Models.Geo.get('inRegion'))) {
            this.controller.Models.Geo.once(
                'change:inRegion',
                _.bind(function() {
                    //this.navigate(requestedFragment, {trigger: true})
                    this.home();
                }, this)
            );
            //this.navigate('loading/generic', {trigger: false});
            return false;
        } else if (!this.controller.Models.Geo.get('inRegion')) {
            this.geo();
            return false;
        }

        // is the window closed?
        if (this.cms.get('window_status') === '0') {
            //this.navigate('error/window', {trigger: true});
            this.error('window');

            return false;
        }

        // is the winner displayed?
        if(_.checkIfTrue(this.cms.get('text')['view_winner'].display)) {
            this.winner();
            return false;
        }

        return true;
    },
    /**
     *
     */
    saveHistory: function(router, route, params) {
        this.history.push({
            name: route,
            args: params,
            fragment: Backbone.history.fragment
        });
        console.log('saveHistory', Backbone.history.fragment, route);
    },

    /**
     * scrollToTop
     */
    scrollToTop: function() {
        console.log('scroll to top');

        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            window.scrollTo(0, 0);
        } else {
            $('html, body').animate(
                {
                    scrollTop: -100
                },
                '600'
            );
        }

        if(this.pym) this.pym.sendMessage('scrollToChildPosition',JSON.stringify({ y: -150 }));
    }

});



// WEBPACK FOOTER //
// ./app/scripts/routes/router.js